module.exports = __webpack_public_path__ + "static/media/order-now-hover.cc488a2f.png";